<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <!-- <admin-sidebar-menu v-if="admin" /> -->
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Add Instructor</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div class="content-main-wrapper signin-form add_account_form center">
            <form @submit.prevent="onSubmit">
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
          			<label
          					for="first_name"
          					class="col-12">First name : <span class="required">*</span></label>
          			<input
          					type="first_name"
          					name="first_name"
          					id="first_name"
          					class="col-12 col-sm-12 input-height-35"
          					ref="first_name"
          					v-validate="'required'"
                    data-vv-as="First name"
          					v-model="first_name"
                    maxlength="180">
          			<div v-show="verrors.has('first_name')" class="validate-warning-msg">{{ verrors.first('first_name') }}</div>
          		  </div>
          		</div>
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
          			<label
          					for="last_name"
          					class="col-12">Last name : <span class="required">*</span></label>
          			<input
          					type="last_name"
          					name="last_name"
          					id="last_name"
          					class="col-12 col-sm-12 input-height-35"
          					ref="last_name"
          					v-validate="'required'"
                    data-vv-as="Last name"
          					v-model="last_name"
                    maxlength="180">
          			<div v-show="verrors.has('last_name')" class="validate-warning-msg">{{ verrors.first('last_name') }}</div>
          		  </div>
          		</div>
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
          			<label
          					for="phone_number"
          					class="col-12">Phone number :</label>
          			<input
          					type="phone_number"
          					name="phone number"
          					id="phone_number"
          					class="col-12 col-sm-12 input-height-35"
          					ref="phone_number"
          					v-validate="'numeric'"
                    data-vv-as="Phone number"
          					v-model="phone_number"
                    maxlength="20">
          			<div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
          		  </div>
          		</div>
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
            			<label
            					for="email"
            					class="col-12">Email address : <span class="required">*</span></label>
            			<input
            					type="email_addr"
            					name="email"
            					id="email_addr"
            					class="col-12 col-sm-12 input-height-35"
            					ref="email_addr"
            					v-validate="'required|email'"
                      data-vv-as="Email address"
            					v-model="email_addr"
                      maxlength="180">
            			<div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
          		  </div>
          		</div>
              <div class="row margin-bottom-15">
                <div class="col-12 col-sm-12">
                  <label
                      for="groups"
                      class="col-12">Groups :</label>
                  <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in groups">
                    <div class="chkboxwrapper">
                      <input :value="option.id" :id="option.id" type="checkbox" name="groups_assigned" v-model="groups_assigned"  class="float-left" style="margin-top: 2px;">
                      <label :for="option.groupName" class="float-left" style="margin-left: 4px;">{{ option.groupName }}</label>
                      <div style="clear: both;"></div>
                    </div>
                  </div>
               </div>
              </div>

              <div class="submit margin-bottom-15">
                <button type="submit" class="btn btn-info btn-md">Add this Instructor</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import store from '../../store/store.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
	    password: '',
      pw_confirm: '',
      groups: [],
      groups_assigned: [],
      accountId: '',
      admin: false,
    }
  },
  methods: {
    onSubmit () {
        this.$validator.validateAll().then((result) => {
          if(!result) {
            return;
          }
          this.createInstructor();
        })
        .catch(() => {

        });
    },
  createInstructor() {
      //make axios call to the API
      axios('/users',
        {
          method: 'POST',
          data: {
                 "username": this.email_addr,
                 "email": this.email_addr,
                 "roles": ["ROLE_INSTRUCTOR"],
                 "first_name": this.first_name,
                 "last_name": this.last_name,
                 "groups_assigned": this.groups_assigned,
                 "enabled": true,
                 "signin_count": 0,
                 "account_id": this.accountId,
                 }
        },
      )
      .then(response => {
          this.flash({ message: response.data.successMsg, variant: 'success' });
          if(this.accountId) {
            this.navigate('/list-account-users/' + this.accountId);
          }
          else {
            this.navigate('/school-admin-dashboard');
          }
       })
      .catch(error => {
          const fieldErrors =  [{}];
          var errMsgObj = error.response.data.message;
          Object.keys(errMsgObj).map(key => {
             var newFieldErr = {field:key, msg:errMsgObj[key]};
             fieldErrors.push(newFieldErr);
          });
          this.$validator.errors.add(fieldErrors);
       });
  },
  navigate(path) {
    router.push(path);
  },
  },
  beforeCreate() {
      axios('/accountgroups',
        {
          method: 'GET',
          params: {
            account_id: this.$route.params.account_id,
          }
        },
      )
      .then(response => {
            this.groups = response.data;
       })
      .catch(error => {

      });
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  },
  created: function() {
    this.accountId = this.$route.params.account_id;
    var roles = this.$store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
  }
}
</script>

<style>
.tasklist-assign-wrapper label {
  font-weight: normal;
}
.tasklist-assign-wrapper .chkboxwrapper {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/add_instructor.vue